import { extendServiceContainer } from '@iotize/tap';
import { TimeService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    time: TimeService;
  }
}

export const _TAP_SERVICE_EXTENSION_TIME_ = extendServiceContainer(
  'time',
  TimeService,
);
